import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import Icon from "@/lib/components/Icon";
import {ReactNode} from "react";

type Props = {
    children: ReactNode,
}

export default function Location({children}: Props) {
    return (
        <View>
            <View style={styles.line}>
                <Icon kind={"location"}/>
                <Text style={styles.text}>{children}</Text>
            </View>
        </View>
    )
}

export const styles = StyleSheet.create({
    text: {
        color: Color.PrimaryText,
        fontSize: 16,
        marginRight: 6,
    },
    line: {
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
    }
})